import React from 'react';
import { Edit } from 'lucide-react';

/**
 * Edit button. By default a round icon-only button (used across the app). Pass
 * a `label` (e.g. "Edit") to render a labeled pill instead.
 */
const EditButton = ({ onClick, className = '', label, ...props }) => {
  if (label) {
    return (
      <button
        onClick={onClick}
        className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 transition ${className}`}
        {...props}
      >
        <Edit className="h-4 w-4" />
        {label}
      </button>
    );
  }
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-900 transition ${className}`}
      {...props}
    >
      <Edit className="h-5 w-5" />
    </button>
  );
};

export default EditButton;
